// SPDX-License-Identifier: AGPL-3.0-or-later

import * as AccessibilityCommands from '@app/features/accessibility/commands/AccessibilityCommands';
import {Logger} from '@app/features/platform/utils/AppLogger';
import {ThemeAcceptModal} from '@app/features/theme/components/modals/ThemeAcceptModal';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import * as ToastCommands from '@app/features/ui/commands/ToastCommands';
import type {I18n} from '@lingui/core';
import {msg} from '@lingui/core/macro';

const logger = new Logger('Themes');
export function applyTheme(css: string, i18n: I18n): void {
	try {
		AccessibilityCommands.update({customThemeCss: css});
		ToastCommands.success(i18n._(msg`Imported theme has been applied.`));
	} catch (error) {
		logger.error('Failed to apply theme:', error);
		ToastCommands.error(i18n._(msg`We couldn't apply this theme.`));
		throw error;
	}
}
export function openAcceptModal(themeId: string | undefined, i18n: I18n): void {
	if (!themeId) {
		ToastCommands.error(i18n._(msg`This theme link is missing data.`));
		return;
	}
	ModalCommands.pushWithKey(
		modal(() => <ThemeAcceptModal themeId={themeId} />),
		`theme-accept-${themeId}`,
	);
}
